import { render, staticRenderFns } from "./satisfactionStatistics.vue?vue&type=template&id=f38727fc&scoped=true&"
import script from "./satisfactionStatistics.vue?vue&type=script&lang=ts&"
export * from "./satisfactionStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./satisfactionStatistics.vue?vue&type=style&index=0&id=f38727fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38727fc",
  null
  
)

export default component.exports